import { useMemo } from 'react';
import { useApp } from '@/store';
import {
  rightsFor,
  type PermAction,
  type SectionId,
  type SectionRights,
} from '@/lib/section-permissions';

// Stable fallback so the selector does not hand zustand a new array on every
// render before a user is known.
const NO_ROLES: string[] = [];

/** The signed-in user's roles; re-renders on login / logout / refresh. */
export function useRoles(): string[] {
  return useApp(s => s.currentUser?.roles ?? NO_ROLES);
}

/** The signed-in user's effective section rights (client #95). */
export function useSectionRights(): SectionRights {
  const roles = useRoles();
  // Optional chaining: page tests mock the store with partial state.
  const permissions = useApp(s => s.settings?.permissions);
  const permMatrix = useApp(s => s.settings?.permMatrix);
  return useMemo(
    () => rightsFor(roles, { permissions, permMatrix }),
    [roles, permissions, permMatrix]
  );
}

export function useCan(section: SectionId, action: PermAction): boolean {
  return useSectionRights()[section][action];
}
